<template>
    <v-toolbar :color="toolbarColor" dense elevation="0" dark>
        <v-icon left color="white">mdi-handshake</v-icon>
        <v-toolbar-title>Pairing &amp; Placement</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    computed: {
        toolbarColor() {
            return '#0A7029';
        }
    }
}
</script>